import { useEffect } from 'react';

import { useCookieConsent } from '../../Hooks/useCookieConsent';
import { loadMetaPixel, unloadMetaPixel } from '../../utils/cookieManager';

const MetaPixel = () => {
  const { consent } = useCookieConsent();

  useEffect(() => {
    if (consent.marketing) {
      loadMetaPixel();
    } else {
      unloadMetaPixel();
    }
  }, [consent.marketing]);

  return null;
};

export default MetaPixel;
